"use strict";

exports.__esModule = true;
exports.formatColumns = formatColumns;
exports.getSortIndex = getSortIndex;
var _react = _interopRequireDefault(require("react"));
var _ColumnFilter = require("./ColumnFilter");
var _columnFormatters = require("./columnFormatters");
var _columnSorter = require("./columnSorter");
var _createDownloadCellFormatter = require("./createDownloadCellFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var isNil = require("ramda").isEmpty;
function getSortIndex(columns) {
  return columns.reduce(function (acc, item) {
    acc[item.name] = item.sortIndex;
    return acc;
  }, {});
}
function colFilterMethod(id) {
  return function (filter, row) {
    var _filter$value = filter.value,
      value = _filter$value === void 0 ? [] : _filter$value;
    if (!value.length) {
      return true;
    }
    var val = row[id];
    return val !== "undefined" ? value.includes(val) : true;
  };
}
function doNothing() {
  return {};
}
function getHeader(column) {
  return function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textAlign: "left"
      }
    }, column.label);
  };
}

/**
 * Format columns to render ReactTable
 * Note: 'id' is required and used to create accessor
 *
 * @param columns
 * @param data
 * @param contexts
 * @param hasSubComponent?
 * @returns {Array<{filterable: *, filterMethod: Function, DownloadCellFormatter: Function, sorter: ColumnSorter, accessor: (*|string), canSort: boolean, sortable: boolean, type: *, canFilter: *, canSearch: *, sortMethod: *, Header: (function(): *), Filter: ColumnFilterMethod, name: *, id: (*|string), Cell: CellFormatterForARow}>}
 */
function formatColumns(columns, data, contexts, hasSubComponent) {
  var translate = contexts.translate,
    time = contexts.time,
    devices = contexts.devices,
    plantStateActivities = contexts.plantStateActivities,
    users = contexts.users,
    ticketTypes = contexts.ticketTypes;
  var devicesMap = devices.reduce(function (acc, device) {
    acc[device.uuid] = device.name;
    return acc;
  }, {});
  var statesMap = plantStateActivities.states.reduce(function (acc, state) {
    acc[state.id] = state.name;
    return acc;
  }, {});
  var activitiesMap = plantStateActivities.activities.reduce(function (acc, activity) {
    acc[activity.id] = activity.name;
    return acc;
  }, {});
  return columns.map(function (column) {
    var formatter = (0, _columnFormatters.createCellFormatter)({
      column: column,
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      data: data,
      devicesMap: devicesMap,
      statesMap: statesMap,
      activitiesMap: activitiesMap,
      users: users,
      ticketTypes: ticketTypes,
      hasSubComponent: hasSubComponent
    });
    var Cell = (0, _columnFormatters.createCellWrapper)({
      column: column,
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      data: data,
      devicesMap: devicesMap,
      statesMap: statesMap,
      activitiesMap: activitiesMap,
      users: users,
      ticketTypes: ticketTypes,
      hasSubComponent: hasSubComponent
    });
    var type = column.type || column.id || column.groupId || "";
    return Object.assign({
      id: isNil(column.id) ? column.groupId : column.id,
      name: column.label || column.name,
      titleOverridden: column.titleOverridden,
      accessor: column.id || column.groupId,
      type: column.type,
      Header: getHeader(column),
      sortable: false,
      canSort: column.enableSorting ? column.enableSorting : false,
      canFilter: column.canFilter,
      exactMatch: column.exactMatch,
      minWidth: parseInt(column.defaultWidth || column.minWidth || 100)
    }, column.defaultWidth ? {
      width: parseInt(column.defaultWidth),
      maxWidth: parseInt(column.defaultWidth)
    } : {}, {
      defaultFilterValue: column.defaultFilterValue,
      canSearch: column.canSearch,
      filterable: column.canFilter,
      Cell: Cell,
      actionsComponent: column.actionsComponent,
      isAggregated: column.isAggregated,
      cellFormatter: formatter,
      sortMethod: (0, _columnSorter.getColumnSorter)({
        devicesMap: devicesMap,
        statesMap: statesMap,
        activitiesMap: activitiesMap,
        users: users,
        formatter: formatter,
        type: type.trim()
      }),
      sorter: (0, _columnSorter.getColumnSorter)({
        devicesMap: devicesMap,
        statesMap: statesMap,
        activitiesMap: activitiesMap,
        users: users,
        formatter: formatter,
        type: type.trim()
      }),
      Filter: (0, _ColumnFilter.ColumnFilter)(column.id, devicesMap, statesMap, activitiesMap, formatter, data),
      filterMethod: colFilterMethod(column.id),
      DownloadCellFormatter: (0, _createDownloadCellFormatter.createDownloadCellFormatter)({
        column: column,
        translate: translate,
        time: time,
        devices: devices,
        plantStateActivities: plantStateActivities,
        devicesMap: devicesMap,
        ticketTypes: ticketTypes,
        users: users
      }),
      getProps: column.getProps || doNothing
    });
  });
}